export const translations = {
  it: {
    // General
    appName: "Dungeon Wallet",
    language: "Lingua",
    theme: "Tema",
    settings: "Impostazioni",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    edit: "Modifica",
    confirm: "Conferma",
    back: "Indietro",
    close: "Chiudi",
    
    // Themes
    themeLight: "Chiaro",
    themeDark: "Scuro",
    themeParchment: "Pergamena",
    
    // Characters
    characters: "Personaggi",
    createCharacter: "Crea Personaggio",
    characterCreated: "{{name}} Creato!",
    editCharacter: "Modifica Personaggio",
    deleteCharacter: "Elimina Personaggio",
    characterName: "Nome Personaggio",
    selectSystem: "Sistema di Gioco",
    noCharacters: "Nessun personaggio",
    createFirstCharacter: "Crea il tuo primo personaggio per iniziare",
    deleteCharacterConfirm: "Sei sicuro di voler eliminare questo personaggio?",
    selectCharacter: "Seleziona un personaggio",
    openWallet: "Apri Portafoglio",
    
    // Wallet
    wallet: "Portafoglio",
    totalValue: "Valore Totale",
    add: "Aggiungi",
    spend: "Spendi",
    addCoins: "Aggiungi Monete",
    spendCoins: "Spendi Monete",
    amount: "Quantità",
    coinType: "Tipo di Moneta",
    insufficientFunds: "Fondi insufficienti",
    transactionSuccess: "Transazione completata",
    emptyAll: "Svuota Tutto",
    
    // Empty All confirmations
    emptyConfirm1: "Sei sicuro? Perderai TUTTE le monete!",
    emptyConfirm2: "Ma davvero davvero? Il drago sarà deluso...",
    emptyConfirm3: "Ultima chance!",
    emptySuccess: "Portafoglio svuotato! Speriamo tu sappia cosa fai...",
    
    // Notes
    addNote: "Aggiungi nota (opzionale)",
    note: "Nota",
    
    // History
    history: "Cronologia",
    noTransactions: "Nessuna transazione",
    received: "Ricevuto",
    spent: "Speso",
    goalDeposit: "Deposito obiettivo",
    goalWithdraw: "Prelievo obiettivo",
    
    // Goals
    goals: "Obiettivi",
    createGoal: "Crea Obiettivo",
    editGoal: "Modifica Obiettivo",
    goalName: "Nome Obiettivo",
    targetAmount: "Importo Target",
    noGoals: "Nessun obiettivo",
    createFirstGoal: "Crea il tuo primo obiettivo di risparmio",
    progress: "Progresso",
    goalReached: "Obiettivo raggiunto!",
    deleteGoalConfirm: "Sei sicuro di voler eliminare questo obiettivo?",
    depositToGoal: "Deposita",
    withdrawFromGoal: "Preleva",
    currentSaved: "Risparmiato",
    goalFunds: "Fondi dedicati",
    
    // Backup
    backup: "Backup",
    restore: "Ripristina",
    backupSuccess: "Backup completato",
    restoreSuccess: "Ripristino completato",
    restoreError: "Errore nel ripristino",
    invalidBackupFile: "File di backup non valido",
    
    // Currencies
    copper: "Rame",
    silver: "Argento",
    electrum: "Electrum",
    gold: "Oro",
    platinum: "Platino",
    brassPennies: "Penny di Ottone",
    silverShillings: "Scellini d'Argento",
    goldCrowns: "Corone d'Oro",
    
    // Systems
    dnd5e: "D&D 5e",
    dnd35: "D&D 3.5",
    pf2e: "Pathfinder 2e",
    wfrp4e: "Warhammer Fantasy 4e",
  },
  en: {
    // General
    appName: "Dungeon Wallet",
    language: "Language",
    theme: "Theme",
    settings: "Settings",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    confirm: "Confirm",
    back: "Back",
    close: "Close",
    
    // Themes
    themeLight: "Light",
    themeDark: "Dark",
    themeParchment: "Parchment",
    
    // Characters
    characters: "Characters",
    createCharacter: "Create Character",
    characterCreated: "{{name}} created!",
    editCharacter: "Edit Character",
    deleteCharacter: "Delete Character",
    characterName: "Character Name",
    selectSystem: "Game System",
    noCharacters: "No characters",
    createFirstCharacter: "Create your first character to get started",
    deleteCharacterConfirm: "Are you sure you want to delete this character?",
    selectCharacter: "Select a character",
    openWallet: "Open Wallet",
    
    // Wallet
    wallet: "Wallet",
    totalValue: "Total Value",
    add: "Add",
    spend: "Spend",
    addCoins: "Add Coins",
    spendCoins: "Spend Coins",
    amount: "Amount",
    coinType: "Coin Type",
    insufficientFunds: "Insufficient funds",
    transactionSuccess: "Transaction completed",
    emptyAll: "Empty All",
    
    // Empty All confirmations
    emptyConfirm1: "Are you sure? You'll lose ALL your coins!",
    emptyConfirm2: "Really really? The dragon will be disappointed...",
    emptyConfirm3: "Last chance!",
    emptySuccess: "Wallet emptied! Hope you know what you're doing...",
    
    // Notes
    addNote: "Add note (optional)",
    note: "Note",
    
    // History
    history: "History",
    noTransactions: "No transactions",
    received: "Received",
    spent: "Spent",
    goalDeposit: "Goal deposit",
    goalWithdraw: "Goal withdraw",
    
    // Goals
    goals: "Goals",
    createGoal: "Create Goal",
    editGoal: "Edit Goal",
    goalName: "Goal Name",
    targetAmount: "Target Amount",
    noGoals: "No goals",
    createFirstGoal: "Create your first savings goal",
    progress: "Progress",
    goalReached: "Goal reached!",
    deleteGoalConfirm: "Are you sure you want to delete this goal?",
    depositToGoal: "Deposit",
    withdrawFromGoal: "Withdraw",
    currentSaved: "Saved",
    goalFunds: "Dedicated funds",
    
    // Backup
    backup: "Backup",
    restore: "Restore",
    backupSuccess: "Backup completed",
    restoreSuccess: "Restore completed",
    restoreError: "Restore error",
    invalidBackupFile: "Invalid backup file",
    
    // Currencies
    copper: "Copper",
    silver: "Silver",
    electrum: "Electrum",
    gold: "Gold",
    platinum: "Platinum",
    brassPennies: "Brass Pennies",
    silverShillings: "Silver Shillings",
    goldCrowns: "Gold Crowns",
    
    // Systems
    dnd5e: "D&D 5e",
    dnd35: "D&D 3.5",
    pf2e: "Pathfinder 2e",
    wfrp4e: "Warhammer Fantasy 4e",
  }
};

export const getCurrencyName = (currencyId, lang) => {
  const currencyMap = {
    cp: lang === 'it' ? 'Rame' : 'Copper',
    sp: lang === 'it' ? 'Argento' : 'Silver',
    ep: lang === 'it' ? 'Electrum' : 'Electrum',
    gp: lang === 'it' ? 'Oro' : 'Gold',
    pp: lang === 'it' ? 'Platino' : 'Platinum',
    d: lang === 'it' ? 'Penny di Ottone' : 'Brass Pennies',
    s: lang === 'it' ? 'Scellini d\'Argento' : 'Silver Shillings',
    gc: lang === 'it' ? 'Corone d\'Oro' : 'Gold Crowns',
  };
  return currencyMap[currencyId] || currencyId;
};
